<template>
  <div>
    <!-- <div v-for="(item, index) in ProductTypeList" :key="index"> -->
    <div id="bathroom">
      <div class="top_div">
        <img class="home_banner" :src="ProductTypeList[0].cover" />
        <div class="home_banner_hover"></div>
        <div class="div_top_title">
          <p>{{ ProductTypeList[0].titleCn }}</p>
          <p class="p_title_sub">{{ ProductTypeList[0].titleEn }}</p>
          <p class="p_title_sub">{{ ProductTypeList[0].titleEnSub }}</p>
        </div>
      </div>
      <div class="swiper_father">
        <div class="swiper-button-prev swiper-button-prev1"></div>
        <div class="swiper-container mySwiper mySwiper1">
          <div class="swiper-wrapper" @click="navto()">
            <div
              class="swiper-slide"
              v-for="(item, index) in ProductList1"
              :key="index"
              
            >
              <img :src="item.cover" />
            </div>
          </div>
        </div>
        <div class="swiper-button-next swiper-button-next1"></div>
      </div>
    </div>
    <div id="valve">
      <div class="top_div">
        <img class="home_banner" :src="ProductTypeList[1].cover" />
        <div class="home_banner_hover"></div>
        <div class="div_top_title">
          <p>{{ ProductTypeList[1].titleCn }}</p>
          <p class="p_title_sub">{{ ProductTypeList[1].titleEn }}</p>
          <p class="p_title_sub">{{ ProductTypeList[1].titleEnSub }}</p>
        </div>
      </div>
      <div class="swiper_father">
        <div class="swiper-button-prev swiper-button-prev2"></div>
        <div class="swiper-container mySwiper mySwiper2">
          <div class="swiper-wrapper" @click="navto()">
            <div
              class="swiper-slide"
              v-for="(item, index) in ProductList2"
              :key="index"
            >
              <img :src="item.cover" />
            </div>
          </div>
        </div>
        <div class="swiper-button-next swiper-button-next2"></div>
      </div>
      <!-- <p @click="navto()">JumpPager</p> -->
    </div>
    <div id="water">
      <div class="top_div">
        <img class="home_banner" :src="ProductTypeList[2].cover" />
        <div class="home_banner_hover"></div>
        <div class="div_top_title">
          <p>{{ ProductTypeList[2].titleCn }}</p>
          <p class="p_title_sub">{{ ProductTypeList[2].titleEn }}</p>
          <p class="p_title_sub">{{ ProductTypeList[2].titleEnSub }}</p>
        </div>
      </div>
      <div class="swiper_father">
        <div class="swiper-button-prev swiper-button-prev3"></div>
        <div class="swiper-container mySwiper mySwiper3">
          <div class="swiper-wrapper" @click="navto()">
            <div
              class="swiper-slide"
              v-for="(item, index) in ProductList3"
              :key="index"
            >
              <img :src="item.cover" />
            </div>
          </div>
        </div>
        <div class="swiper-button-next swiper-button-next3"></div>
      </div>
      <!-- <p @click="navto()">JumpPager</p> -->
    </div>
    <div id="hvac">
      <div class="top_div">
        <img class="home_banner" :src="ProductTypeList[3].cover" />
        <div class="home_banner_hover"></div>
        <div class="div_top_title">
          <p>{{ ProductTypeList[3].titleCn }}</p>
          <p class="p_title_sub">{{ ProductTypeList[3].titleEn }}</p>
          <p class="p_title_sub">{{ ProductTypeList[3].titleEnSub }}</p>
        </div>
      </div>
      <div class="swiper_father">
        <div class="swiper-button-prev swiper-button-prev4"></div>
        <div class="swiper-container mySwiper mySwiper4">
          <div class="swiper-wrapper" @click="navto()">
            <div
              class="swiper-slide"
              v-for="(item, index) in ProductList4"
              :key="index"
            >
              <img :src="item.cover" />
            </div>
          </div>
        </div>
        <div class="swiper-button-next swiper-button-next4"></div>
      </div>
      <!-- <p @click="navto()">JumpPager</p> -->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      path: "bathroom",
      ProductList1: [
        {
          cover: "",
          titleCn: "",
          titleEn: "",
          titleEnSub: "",
        },
      ],
      ProductList2: [
        {
          cover: "",
          titleCn: "",
          titleEn: "",
          titleEnSub: "",
        },
      ],
      ProductList3: [
        {
          cover: "",
          titleCn: "",
          titleEn: "",
          titleEnSub: "",
        },
      ],
      ProductList4: [
        {
          cover: "",
          titleCn: "",
          titleEn: "",
          titleEnSub: "",
        },
      ],
      ProductTypeList: [
        {
          banner: "",
          cover: "",
          midImg: "",
          titleCn: "",
          titleEn: "",
          titleEnSub: "",
        },
        {
          banner: "",
          cover: "",
          midImg: "",
          titleCn: "",
          titleEn: "",
          titleEnSub: "",
        },
        {
          banner: "",
          cover: "",
          midImg: "",
          titleCn: "",
          titleEn: "",
          titleEnSub: "",
        },
        {
          banner: "",
          cover: "",
          midImg: "",
          titleCn: "",
          titleEn: "",
          titleEnSub: "",
        },
      ],
    };
  },
  components: {},
  mounted() {
    this.Init();
    var param = this.$route.query.param;
    this.path = param;
    console.log("param:" + param);
    this.navtoPartPath(this.path);
  },
  watch: {
    $route(to, from) {
      console.log(to.path);
      var param = this.$route.query.param;
      this.path = param;
      console.log("param:" + param);
      this.navtoPartPath(this.path);
    },
    ProductList1() {
      this.$nextTick(() => {
        var swiper1 = new Swiper(".mySwiper1", {
          loop: true,
          autoplay: {
            delay: 1500,
            disableOnInteraction: false,
          },
          spaceBetween: 10,
          slidesPerView: 6,
          freeMode: true,
          watchSlidesVisibility: true,
          watchSlidesProgress: true,
          navigation: {
            nextEl: ".swiper-button-next1",
            prevEl: ".swiper-button-prev1",
          },
        });
      });
    },
    ProductList2() {
      this.$nextTick(() => {
        var swiper2 = new Swiper(".mySwiper2", {
          loop: true,
          autoplay: {
            delay: 1500,
            disableOnInteraction: false,
          },
          spaceBetween: 10,
          slidesPerView: 6,
          freeMode: true,
          watchSlidesVisibility: true,
          watchSlidesProgress: true,
          navigation: {
            nextEl: ".swiper-button-next2",
            prevEl: ".swiper-button-prev2",
          },
        });
      });
    },
    ProductList3() {
      this.$nextTick(() => {
        var swiper3 = new Swiper(".mySwiper3", {
          loop: true,
          autoplay: {
            delay: 1500,
            disableOnInteraction: false,
          },
          spaceBetween: 10,
          slidesPerView: 6,
          freeMode: true,
          watchSlidesVisibility: true,
          watchSlidesProgress: true,
          navigation: {
            nextEl: ".swiper-button-next3",
            prevEl: ".swiper-button-prev3",
          },
        });
      });
    },
    ProductList4() {
      this.$nextTick(() => {
        var swiper4 = new Swiper(".mySwiper4", {
          loop: true,
          autoplay: {
            delay: 1500,
            disableOnInteraction: false,
          },
          spaceBetween: 10,
          slidesPerView: 6,
          freeMode: true,
          watchSlidesVisibility: true,
          watchSlidesProgress: true,
          navigation: {
            nextEl: ".swiper-button-next4",
            prevEl: ".swiper-button-prev4",
          },
        });
      });
    },
  },
  methods: {
    Init() {
      this.getProductType();
    },
    navtoPartPath(path) {
      setTimeout(() => {
        document.getElementById(path).scrollIntoView();
      }, 500);
    },
    getProductType() {
      let that = this;
      this.$axios
        .get("app/producttype/list")
        .then(function (response) {
          console.log(response);
          var status = response.data.code;
          if (status === 0) {
            that.ProductTypeList = response.data.page.list;
            that.getProductList1(that.ProductTypeList[0].id);
            that.getProductList2(that.ProductTypeList[1].id);
            that.getProductList3(that.ProductTypeList[2].id);
            that.getProductList4(that.ProductTypeList[3].id);
            console.log(that.ProductTypeList);
            // sessionStorage.setItem("input", "null");
          }
        })
        .catch((err) => console.log(err));
    },
    getProductList1(id) {
      let that = this;
      this.$axios
        .get("app/products/list",{
          params: {
            typeId: id,
          },
        })
        .then(function (response) {
          // console.log(response);
          var status = response.data.code;
          if (status === 0) {
            that.ProductList1 = response.data.page.list;
            // console.log(that.ProductList1);
            // sessionStorage.setItem("input", "null");
          }
        })
        .catch((err) => console.log(err));
    },
    getProductList2(id) {
      let that = this;
      this.$axios
        .get("app/products/list",{
          params: {
            typeId: id,
          },
        })
        .then(function (response) {
          // console.log(response);
          var status = response.data.code;
          if (status === 0) {
            that.ProductList2 = response.data.page.list;
            // console.log(that.ProductList2);
            // sessionStorage.setItem("input", "null");
          }
        })
        .catch((err) => console.log(err));
    },
    getProductList3(id) {
      let that = this;
      this.$axios
        .get("app/products/list",{
          params: {
            typeId: id,
          },
        })
        .then(function (response) {
          // console.log(response);
          var status = response.data.code;
          if (status === 0) {
            that.ProductList3 = response.data.page.list;
            // console.log(that.ProductList3);
            // sessionStorage.setItem("input", "null");
          }
        })
        .catch((err) => console.log(err));
    },
    getProductList4(id) {
      let that = this;
      this.$axios
        .get("app/products/list",{
          params: {
            typeId: id,
          },
        })
        .then(function (response) {
          // console.log(response);
          var status = response.data.code;
          if (status === 0) {
            that.ProductList4 = response.data.page.list;
            // console.log(that.ProductList4);
            // sessionStorage.setItem("input", "null");
          }
        })
        .catch((err) => console.log(err));
    },
    navto(id) {
      this.$router.push("/JumpPager");
    },

  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
.top_div {
  height: 100%;
  position: relative;
}

.div_top_title {
  position: absolute;
  left: 20rem;
  bottom: 5rem;
  color: white;
  font-size: 3.6rem;
  font-family: medium;
  text-align: left;
  text-shadow: 4px 4px 6px rgba(0, 0, 0, 0.5);

  .p_title_sub {
    font-size: 4rem;
    line-height: 4rem;
    font-family: bin_num_din;
  }

  .litter_line_top {
    margin: 1rem auto 3rem;
    background-color: var(--textWhiteColor40);
    box-shadow: 3px 3px 3px 0px rgba(0, 0, 0, 0.4);
    height: 1px;
    width: 6%;
  }
}

.home_banner_hover {
  width: 100%;
  height: 100%;
  background: var(--textBlackColor30);
  position: absolute;
  top: 0;
}

.home_banner {
  height:78rem;
  width: 100%;
  object-fit :cover;
  margin-left: auto;
  margin-right: auto;
  --swiper-pagination-color: #ec8938;

  div {
    width: 100%;
    height: 50vw;
    margin-left: auto;
    margin-right: auto;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}

.swiper-container {
  width: 100%;
  height: 100%;
}

.swiper-slide {
  text-align: center;
  font-size: 18px;
  background: #fff;
  /* Center slide text vertically */
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
}

.swiper-slide img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.swiper-container {
  width: 100%;
  height: 300px;
  margin-left: auto;
  margin-right: auto;
}

.swiper-slide {
  background-size: cover;
  background-position: center;
}

.swiper_father {
  position: relative;
  // align-items :center;
}

.mySwiper {
  width: 80%;
  height: 20%;
  box-sizing: border-box;
  margin: 10px auto;
}

.swiper-button-next {
  background: var(--textGaryColor);
  color: white;
  height: 10rem;
  width: 4rem;
  top: 35%;
  margin-right: 5%;
}

.swiper-button-prev {
  background: var(--textGaryColor);
  color: white;
  height: 10rem;
  width: 4rem;
  top: 35%;
  margin-left: 5%;
}

.swiper-button-disabled{
  pointer-events :auto;
  opacity:1;
}
.swiper-button-prev:hover {
  opacity:1;
  background: var(--textBlueColor) !important;
}
.swiper-button-next:hover {
  opacity:1;
  background: var(--textBlueColor) !important;
}

.swiper-button-prev:after{
  font-size:3rem;
}
.swiper-button-next:after{
  font-size:3rem;
}

.mySwiper .swiper-slide {
  width: 25%;
  height: 100%;
  // opacity: 0.4;//蒙层
}

.mySwiper .swiper-slide-thumb-active {
  opacity: 1;
}

@media screen and (max-width: 1200px) {
  #bathroom {
    height: 100vh;
    position: relative;
    img{
      object-position :15%;
    }
  }

  #valve {
    height: 100rem;
    position: relative;
  }

  #water {
    height: 100rem;
    position: relative;
  }

  #hvac {
    height: 100rem;
    position: relative;
  }

  .top_div {
    position: absolute;

    // height: 90rem;
    img {
      height: 100%;
      object-fit: cover;
    }
  }

  .div_top_title {
    left: 2rem;
    bottom: 25rem;
  }

  .swiper_father {
    position: absolute;
    bottom: 3rem;
  }

  .mySwiper {
    width: 100%;
  }

  .swiper-slide {
    // height: 15rem !important;
    // width: 15rem !important;
    width: 30% !important;
  }

  .swiper-button-prev {
    display: none;
  }

  .swiper-button-next {
    display: none;
  }
}
</style>
